import { NETWORK_TYPE_LIST, NETWORK_LIST, GET_NETWORK_LIST_REQUEST } from '../constants/action-types';

const initialState = {
    networkTypeList: [],
    networkList: {
        isRequesting: false,
        payload: []
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case NETWORK_TYPE_LIST:
            const networkTypeList = action.payload;
            state = { ...state, networkTypeList }
            break;
        case GET_NETWORK_LIST_REQUEST: {
            state = {
                ...state,
                networkList: {
                    ...state.networkList,
                    isRequesting: true, payload: []
                }
            };
            break;
        }
        case NETWORK_LIST: {
            const payload = action.payload ? action.payload : [];
            state = {
                ...state,
                networkList: {
                    ...state.networkList,
                    isRequesting: false, payload: payload
                }
            };
            break;
        }
        default:
            break;
    }
    return state;
}